<template>
<div>
  <div class="vx-row">

   

    <!-- MULTIPLE COLUMNS-->
    <div class="vx-col w-full mb-base">
      <vx-card title="">
        <div class="vx-row">
          <div class="vx-col sm:w-1/4 w-full mb-1"><v-select :value="program" v-model="program" :options="formatOptions"></v-select></div>
          <div class="vx-col sm:w-1/4 w-full mb-1"><datepicker :format="format" v-model="baslangic"></datepicker></div>
          <div class="vx-col sm:w-1/4 w-full mb-1"><datepicker :format="format" v-model="bitis"></datepicker></div>
          <div class="vx-col sm:w-1/4 w-full mb-1"><vs-input class="inputx" placeholder="Sipariş No" id="siparisM" :ref="siparisNo" v-model="siparisNo" /></div>
          <div class="vx-col sm:w-1/4 w-full mb-1"><vs-button color="success" @click="satisListesi()" type="filled">Listele</vs-button></div>
        </div>

          
       
  

      </vx-card>

      <vs-table :data="data">
        <template slot="thead">
          
          <vs-th>Stok Kodu</vs-th>
          <vs-th>Stok Adı</vs-th>
          <vs-th>Miktar</vs-th>
          <vs-th>Tutar</vs-th>
          <vs-th>Sipariş No</vs-th>
         
        
        </template>

          <template slot-scope="{data}">
            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
              
              <vs-td>
                 {{ data[indextr].sth_stok_kod }}
              </vs-td>
              
              <vs-td>
               {{ data[indextr].stokAdi }}
              </vs-td>
           <vs-td>
               {{ data[indextr].sth_miktar }}
              </vs-td>
             <vs-td>
               {{ data[indextr].sth_tutar }}
              </vs-td>
                           <vs-td>
               {{ data[indextr].siparisNo }} - {{data[indextr].kullanici}}
              </vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td></vs-td>
              <vs-td></vs-td>
              <vs-td>Toplam M.={{ miktarTopla() }}</vs-td>
              <vs-td>Toplam T.={{ tutarTopla() }}</vs-td>
              <vs-td></vs-td>
            </vs-tr>
          </template>

      </vs-table>

    </div>

    
  </div>



  </div>
</template>



<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import state from '../../store/state'
import Store from '../../store/store'
export default{
  data () {
    return {
      format: "yyyy-MM-dd",
      data:[],
      baslangic: '',
      formattedDate: '',
      formattedDate1: '',
      bitis: '',
      siparisNo:'',
      program: {id: 0, label: 'Kullanıcı'},
      check3: '',
      formatOptions: [
        {label: "Miraç", id:"21"},
        {label: "Aylin", id:"20"},
        {label: "Figen", id:"50"},
        {label: "Yaren", id:"54"},
        {label: "Esra", id:"25"},
        {label: "Turgay", id:"98"},
        {label: "Yavuz", id:"97"},
        {label: "Saniye", id:"56"},
      ],
    }
  },methods:{
     miktarTopla() {
      var vm=this
      var sayi=0
      this.data.forEach(element => {
        sayi=sayi+parseInt(element.sth_miktar)
      });
      return sayi
     // this.toplam=parseInt(this.toplam)+parseInt(d)
     // return this.toplam
      //console.log(this.toplam)
    },tutarTopla() {
      var vm=this
      var sayi=0
      this.data.forEach(element => {
        sayi=sayi+parseFloat(element.sth_tutar)
      });
      return Math.round(sayi* 100) / 100
     // this.toplam=parseInt(this.toplam)+parseInt(d)
     // return this.toplam
      //console.log(this.toplam)
    },
satisListesi() {
         var vm = this

        const soap = require('soap')
        const url = state.sistemAddress
    
		var d = new Date(vm.baslangic);
		vm.formattedDate =  d.getUTCFullYear()+"-"+(d.getUTCMonth()+1)+"-"+d.getUTCDate();

    	var d1 = new Date(vm.bitis);
		vm.formattedDate1 =  d1.getUTCFullYear()+"-"+(d1.getUTCMonth()+1)+"-"+d1.getUTCDate(); 
     // console.log(vm.formattedDate)
      const args = {program:'',baslik:'satisKullaniciBazli',tarih1:vm.formattedDate,tarih2:vm.formattedDate1,token:Store.state.tokenId,kullaniciId:this.program.id,siparisNo:this.siparisNo}
     // console.log(args)
      soap.createClient(url, function(err, client){
      client.standartSorguRapor(args, function(err, result){
        if (result.standartSorguRaporResult=='-1') {
          Store.dispatch('logout')
        }
        vm.veriler=JSON.parse(result.standartSorguRaporResult)
        console.log(vm.veriler)
        vm.data=vm.veriler
       // vm.eslesenStokListesi=vm.veriler
        
  
      
      
        
      })
      })
    },
  },
   components: {
    'v-select': vSelect,
    Datepicker
  }
}
</script>
